import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useFeatureFlags } from "../contexts/FeatureFlagContext";
import Loader from "./Loader";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import RedirectHandler from "../components/RedirectHandler";

const ProtectedComponent = ({ component, ...componentProps }) => {
  const { isLoading, isAuthenticated } = useAuth0();
  const currentPath = useLocation().pathname;
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <Loader />,
    returnTo: currentPath,
  });

  const { ajaxLoading, isPathAllowed, wrongEnvironment } = useFeatureFlags();

  if (!isAuthenticated && !isLoading) {
    sessionStorage.setItem("redirectPath", currentPath);
    return <Navigate to="/" state={{ from: currentPath }} replace />;
  }

  if (isLoading || ajaxLoading) {
    return <Loader />;
  }

  if (wrongEnvironment) {
    return <RedirectHandler />;
  }

  if (!isPathAllowed(currentPath)) {
    sessionStorage.setItem("redirectPath", currentPath);
    return <Navigate to="/" state={{ from: currentPath }} replace />;
  }

  return <Component {...componentProps} />;
};

export default ProtectedComponent;
